/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContainerRegistryTypeEnum } from './ContainerRegistryTypeEnum';
import {
    ContainerRegistryTypeEnumFromJSON,
    ContainerRegistryTypeEnumFromJSONTyped,
    ContainerRegistryTypeEnumToJSON,
} from './ContainerRegistryTypeEnum';

/**
 * 
 * @export
 * @interface RegistrySchema
 */
export interface RegistrySchema {
    /**
     * 
     * @type {ContainerRegistryTypeEnum}
     * @memberof RegistrySchema
     */
    type: ContainerRegistryTypeEnum;
}

/**
 * Check if a given object implements the RegistrySchema interface.
 */
export function instanceOfRegistrySchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function RegistrySchemaFromJSON(json: any): RegistrySchema {
    return RegistrySchemaFromJSONTyped(json, false);
}

export function RegistrySchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrySchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': ContainerRegistryTypeEnumFromJSON(json['type']),
    };
}

export function RegistrySchemaToJSON(value?: RegistrySchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': ContainerRegistryTypeEnumToJSON(value.type),
    };
}

